<div class="d-flex font-weight-bold w-100 pb-2 text-primary">
  {{'DATA_STUDIO.DATA_PARAMETERS.AVAILABLE_SIGNALS' | translate}}
</div>
<div class="border rounded w-100 p-2 mb-3 text-primary">
  <div class="d-flex justify-content-between">
    <mat-checkbox [checked]="allSignalsSelected" (change)="selectAllSignals()">
      <b>{{'DATA_STUDIO.SIGNALS.ALL_SIGNALS' | translate}}</b></mat-checkbox>
      <span><small>{{totalSignalsSelected}} {{'COMMON.OF' | translate}} {{totalSignals}}</small></span>
    </div>
    <hr>
      <div class="d-flex flex-wrap">
        @for (signal of csSignals; track $index; let i = $index) {
          <div class="pr-2 signal-item">
            <mat-checkbox [checked]="signal.checked"
              (change)="checkSelectedSignal($event, signal)">
              <span [custom-tooltip]="tooltipTemplate">{{signal.displayName }}
              </span>
            </mat-checkbox>
            <ng-template #tooltipTemplate>
              <div class="info-tooltip rounded p-2">
                <b>{{signal.displayName }}</b><br>
                {{signal.dbName}}
              </div>
            </ng-template>
          </div>
        }
      </div>

    </div>